module.exports = __webpack_public_path__ + "static/media/bermadLogo.2332df61.png";